import { USER_LOGOUT } from 'dux/user';

const rootReducer = ( state = {}, action ) => {
    switch ( action.type ) {
        case USER_LOGOUT:
            const { client, env, ssoAuthenticated, session } = state;
            state = { client, env, ssoAuthenticated, session };
            break;
    }

    return state;
};

export default rootReducer;
